import React from 'react'

function Trade() {
  return (
    <div className='bgHomeColor d-flex align-items-center justify-content-center text-white'>
        <h1 className=''>Coming Soon</h1>

    </div>
  )
}

export default Trade